const gridDateFormat: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'numeric', day: 'numeric', year: '2-digit' };

export const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
export const dateOptionsShort: Intl.DateTimeFormatOptions = { month: 'numeric', day: 'numeric', year: '2-digit' };
export const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

export default gridDateFormat;
